import axios from 'axios';
import authHeader from './auth-header';
import authCustomerHeader from './customer-auth-header';
import Config from '../config/index';
import authFileHeader from "@/services/auth-file-header";

class UserService {
    addUser(user) {
        return axios.post(Config.apiBasePath + '/user/register', user,{ headers: authHeader() });
    }
    getCustomers() {
        return axios.get(Config.apiBasePath + '/admin/customers',{ headers: authHeader() });
    }
    getCustomersByName(search_param) {
        return axios.get(Config.apiBasePath + '/admin/search-customers?search_param='+search_param,{ headers: authHeader() });
    }
    userMessage(user_id,msg_mst_id,page) {
        return axios.get(Config.apiBasePath + '/admin/user-messages?user_id='+user_id+'&msg_mst_id='+msg_mst_id+'&page='+page,{ headers: authHeader() });
    }
    sendOTP(form) {
        return axios.post(Config.apiBasePath + '/user/customer-otp', form,{ headers: authCustomerHeader() });
    }
    addCustomer(user) {
        return axios.post(Config.apiBasePath + '/user/customer-register', user,{ headers: authCustomerHeader() });
    }
    isOffline() {
        return axios.get(Config.apiBasePath + '/user/is-offline',{ headers: authHeader() });
    }
    getUsers() {
        return axios.get(Config.apiBasePath + '/user/all', { headers: authHeader() });
    }
    userSetupData() {
        return axios.get(Config.apiBasePath + '/user/setup-data', { headers: authHeader() });
    }
    userUpdate(user) {
        return axios.post(Config.apiBasePath + '/user/update',user, { headers: authHeader() });
    }
    userUpdateProfile(user) {
        return axios.post(Config.apiBasePath + '/user/update/profile', user, { headers: authFileHeader() });
    }
    userDelete(id) {
        return axios.get(Config.apiBasePath + '/user/delete?id='+id, { headers: authHeader() });
    }
    getUser() {
        return axios.get(Config.apiBasePath + '/user/details', { headers: authHeader() });
    }
    forgetPassword(user) {
        return axios.post(Config.apiBasePath + '/user/forget/password', user);
    }
    changePassword(user) {
        return axios.post(Config.apiBasePath + '/user/change/password', user);
    }
    getSummaryData(){
        return axios.get(Config.apiBasePath + '/summary/operator-calls',{ headers: authHeader() });
    }
    getComplainData(){
        return axios.get(Config.apiBasePath + '/summary/operator-complaints', { headers: authHeader() });
    }
    getAvatarUrl(avatar) {
        return Config.apiBasePath + '/avatars/' + avatar; // + '?time='+ (new Date()).getMilliseconds();
    }

    getUsersForACL() {
        return axios.get(Config.apiBasePath + '/acl/get-users', {headers: authHeader()});
    }

    logout(){
        return axios.post(Config.apiBasePath + '/user/logout', {},{headers: authHeader()});
    }

    checkInternalUser(empCode) {
        return axios.get(Config.apiBasePath + '/user/check-internal', {headers: authHeader(), params: {empCode}});
    }
}

export default new UserService();